<template>
  <div :class="getLocalVideoOffClasses">
    Your video is currently turned off.
  </div>
</template>

<script>
import { getLayoutElementClasses } from "../SessionHelpers/layout";

export default {
  name: "LocalVideoTurnedOff",
  props: {
    localVideoConfig: Number,
  },
  computed: {
    getLocalVideoOffClasses() {
      const config = this.localVideoConfig;
      return getLayoutElementClasses(config, "localVideoOff");
    },
  },
};
</script>